export interface ForumPost {
  id: string
  username: string
  avatar_template: string
  created_at: string
  cooked: string
}

export interface ForumUser {
  user: {
    avatar_template: string
    username: string
  }
}

export interface ForumTopic {
  post_stream?: {
    posts: ForumPost[]
  }
  id: number
  slug: string
  archived: boolean
  visible: boolean
  has_deleted: boolean
  deleted_at: string
  closed: boolean
  posted: boolean
  details: {
    can_archive_topic: boolean
    can_close_topic: boolean
    can_convert_topic: boolean
    can_create_post: boolean
    can_recover: boolean
    can_delete: boolean
    can_edit: boolean
    can_edit_staff_notes: boolean
    can_flag_topic: boolean
    can_invite_to: boolean
    can_invite_via_email: boolean
    can_moderate_category: boolean
    can_move_posts: boolean
    can_pin_unpin_topic: boolean
    can_remove_allowed_users: boolean
    can_remove_self_id: number
    can_reply_as_new_topic: boolean
    can_review_topic: boolean
    can_split_merge_topic: boolean
    can_toggle_topic_visibility: boolean
  }
}

export interface ForumActivityItem {
  excerpt: string
  truncated?: boolean
  action_type: number
  created_at: string
  avatar_template: string
  acting_avatar_template: string
  slug: string
  topic_id: number
  target_user_id: number
  target_username: string
  post_number: number
  post_id: number | null
  username: string
  user_id: number
  acting_username: string
  acting_user_id: number
  title: string
  deleted: boolean
  hidden: boolean | null
  post_type: number | null
  action_code: number | null
  category_id: number
  closed: boolean
  archived: boolean
  userAvatarUrl?: string
  action?: string
  actionUrl?: string
}

export interface ForumActivityResponse {
  user_actions: ForumActivityItem[]
}

export enum ForumActivityActionType {
  USER_LIKED_POST = 1,
  USER_HAD_POST_LIKED = 2,
  USER_BOOKMARKED_POST = 3,
  USER_CREATED_NEW_TOPIC = 4,
  USER_REPLIED_TO_TOPIC = 5,
  USER_RECEIVED_COMMENT = 6,
  USER_WAS_MENTIONED = 7,
  USER_HAS_COMMENT_SET_AS_SOLUTION = 15
}

export const ACCEPTED_FORUM_ACTIVITY_ACTION_TYPES = [
  ForumActivityActionType.USER_LIKED_POST,
  ForumActivityActionType.USER_HAD_POST_LIKED,
  ForumActivityActionType.USER_BOOKMARKED_POST,
  ForumActivityActionType.USER_CREATED_NEW_TOPIC,
  ForumActivityActionType.USER_REPLIED_TO_TOPIC,
  ForumActivityActionType.USER_RECEIVED_COMMENT,
  ForumActivityActionType.USER_WAS_MENTIONED,
  ForumActivityActionType.USER_HAS_COMMENT_SET_AS_SOLUTION
]
